import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { SchemaDatapointEnumOption } from '@rossum/api-client/schemas';
import {
  alpha,
  darken,
  GridLegacy,
  lighten,
  Typography,
  useTheme,
} from '@rossum/ui/material';

type EnumPreviewProps = {
  options: SchemaDatapointEnumOption[];
};

export const EnumPreview = ({ options }: EnumPreviewProps) => {
  const theme = useTheme();
  const intl = useIntl();

  const optionsLength = options.length;

  const color =
    theme.palette.mode === 'light'
      ? lighten(alpha(theme.palette.divider, 1), 0.88)
      : darken(alpha(theme.palette.divider, 1), 0.68);

  return (
    <GridLegacy container justifyContent="center" p={3}>
      <GridLegacy item xs={6}>
        <Typography
          p={2}
          fontWeight={600}
          sx={{
            borderBottom: `1px solid ${color}`,
            borderRight: `1px solid ${color}`,
          }}
        >
          {intl.formatMessage({
            id: 'features.fieldManager.fieldDetail.enumFormulaEditing.enumPreview.id',
          })}
        </Typography>
      </GridLegacy>

      <GridLegacy item xs={6}>
        <Typography
          p={2}
          fontWeight={600}
          sx={{
            borderBottom: `1px solid ${color}`,
          }}
        >
          {intl.formatMessage({
            id: 'features.fieldManager.fieldDetail.enumFormulaEditing.enumPreview.label',
          })}
        </Typography>
      </GridLegacy>
      {options.map((option, index) => {
        return (
          <Fragment key={`${option.value}${option.label}`}>
            <GridLegacy item xs={6}>
              <Typography
                p={2}
                sx={{
                  borderBottom:
                    index !== optionsLength - 1 ? `1px solid ${color}` : 'none',
                  borderRight: `1px solid ${color}`,
                }}
              >
                {option.value}
              </Typography>
            </GridLegacy>

            <GridLegacy item xs={6}>
              <Typography
                p={2}
                sx={{
                  borderBottom:
                    index !== options.length - 1
                      ? `1px solid ${color}`
                      : 'none',
                }}
              >
                {option.label}
              </Typography>
            </GridLegacy>
          </Fragment>
        );
      })}
    </GridLegacy>
  );
};
